class ProductForm extends HTMLElement {
  constructor() {
    super();   

//     this.form = this.querySelector('form');
//     this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//     this.cartNotification = document.querySelector('cart-notification');
//     this.cartDrawer = document.querySelector('cart-drawer');
// ✅ Call auto-selection logic after a short delay
    setTimeout(() => this.selectFirstVariant(), 0);
  }

  selectFirstVariant() {
    const radios = this.querySelectorAll('variant-radios');
    for (const el of radios) {
      const firstRadio = el.querySelector('input[type="radio"]');
      if (firstRadio && !firstRadio.checked) {
        firstRadio.click();
        console.log('✅ First variant radio clicked');
        break;
      }
    }
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('product-form', ProductForm);
